import Placeholder from '~/client/shared/LazyLoad/Placeholder';

const BestGameOfTheWeekPlaceholder: FC = () => <Placeholder height={344} />;
export default BestGameOfTheWeekPlaceholder;
